import { SVGProps } from 'react';

export const TimeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='16'
    height='17'
    viewBox='0 0 16 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M8 4.5V8.5H11M14 8.5C14 11.8137 11.3137 14.5 8 14.5C4.68629 14.5 2 11.8137 2 8.5C2 5.18629 4.68629 2.5 8 2.5C11.3137 2.5 14 5.18629 14 8.5Z'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
